<div class="flex justify-between items-center mb-4 mt-0">
    <h2 class="md:text-xl font-semibold text-sm">Document Timeline</h2>
    <button (click)="isUploadDocument = true" 
            class="bg-blue-600 hover:bg-blue-700 text-white md:px-4 md:py-2
            px-2 py-2
            rounded-lg flex items-center gap-2">
        <i class="pi pi-plus"></i>
        Add Documents
    </button>
</div>

<div *ngIf="loading" class="flex justify-center items-center py-8">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
</div>

<p *ngIf="!loading">
    <app-lead-timeline [title]="''" [isDelete]="true"
    [isDocumentTimeline]="true"
        [timelineData]="leadDocuments"></app-lead-timeline>
</p>

<p-dialog [modal]="true" [(visible)]="isUploadDocument" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isUploadDocument">
        <app-upload-documents [editLeadData]="studentDetails" (reload)="handleDialogClose()"
            (closeDialog)="handleDialogClose()"></app-upload-documents>
    </ng-container>
</p-dialog>